<template>
  <div class="font-example">
    <h1 class="title font-alibaba font-optimized font-title">阿里巴巴普惠体示例</h1>
    
    <div class="content">
      <h2 class="subtitle font-heading font-semibold">标题文字 (SemiBold)</h2>
      <p class="text font-alibaba font-body">
        这是一段使用阿里巴巴普惠体Regular字重的正文内容。阿里巴巴普惠体是一款专为中文优化的字体，
        具有良好的可读性和美观性。它支持多种字重，适合各种场景使用。
      </p>
      
      <div class="font-weights">
        <h3 class="weight-title">不同字重效果：</h3>
        <p class="font-normal">常规文字 (Regular - font-weight: 400)</p>
        <p class="font-semibold">半粗体文字 (SemiBold - font-weight: 600)</p>
      </div>
      
      <div class="usage-examples">
        <h3 class="weight-title">使用场景示例：</h3>
        <div class="example-item">
          <h4 class="font-title">页面标题</h4>
          <p class="font-body">正文内容使用Regular字重，提供良好的可读性。</p>
        </div>
        <div class="example-item">
          <h4 class="font-semibold">重要信息</h4>
          <p class="font-body">重要信息使用SemiBold字重，突出显示。</p>
        </div>
        <div class="example-item">
          <h4 class="font-semibold">按钮文字</h4>
          <p class="font-body">按钮文字使用SemiBold字重，增强视觉层次。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FontExample',
  data() {
    return {
      title: '阿里巴巴普惠体使用示例'
    }
  }
}
</script>

<style lang="scss" scoped>
.font-example {
  padding: $spacing-lg;
  max-width: 800px;
  margin: 0 auto;
  
  .title {
    font-size: 28px;
    margin-bottom: $spacing-lg;
    color: $text-primary;
  }
  
  .subtitle {
    font-size: $font-size-large;
    margin-bottom: $spacing-md;
    color: $text-primary;
  }
  
  .text {
    font-size: $font-size-base;
    line-height: 1.8;
    margin-bottom: $spacing-lg;
    color: $text-regular;
  }
  
  .font-weights {
    margin-bottom: $spacing-lg;
    
    .weight-title {
      font-size: $font-size-large;
      margin-bottom: $spacing-md;
      color: $text-primary;
    }
    
    .font-normal,
    .font-semibold {
      margin-bottom: $spacing-sm;
      font-size: $font-size-base;
      color: $text-regular;
    }
  }
  
  .usage-examples {
    .weight-title {
      font-size: $font-size-large;
      margin-bottom: $spacing-md;
      color: $text-primary;
    }
    
    .example-item {
      margin-bottom: $spacing-md;
      padding: $spacing-md;
      border: 1px solid $border-color-light;
      border-radius: $border-radius-base;
      
      h4 {
        margin-bottom: $spacing-sm;
        color: $text-primary;
      }
      
      p {
        color: $text-regular;
        line-height: 1.6;
      }
    }
  }
  
  @media (max-width: $breakpoint-sm) {
    padding: $spacing-md;
    
    .title {
      font-size: 24px;
    }
    
    .usage-examples .example-item {
      padding: $spacing-sm;
    }
  }
}
</style> 